module.exports = __webpack_public_path__ + "img/loading-white.0ee551e1.svg";